export default __webpack_public_path__ + "static/media/BIFI-BNB.b6fdab4c.svg";